import { render, staticRenderFns } from "./monetaryAccountModal.vue?vue&type=template&id=3a31873a&"
import script from "./monetaryAccountModal.vue?vue&type=script&lang=js&"
export * from "./monetaryAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./monetaryAccountModal.vue?vue&type=style&index=0&id=3a31873a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports